import React from 'react'
import { Box, Card, CardContent, Skeleton, Grid, Stack } from '@mui/material'

export const BillingSkeleton: React.FC = () => {
  return (
    <Box>
      {/* Banner Skeleton */}
      <Skeleton variant="rounded" height={100} sx={{ borderRadius: 3, mb: 3 }} />

      {/* Subscription Cards Skeleton */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={7}>
          <Card sx={{ borderRadius: 3, p: 2 }}>
            <CardContent>
              <Skeleton variant="text" width="40%" height={32} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="60%" height={20} sx={{ mb: 2 }} />
              <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 2 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={5}>
          <Card sx={{ borderRadius: 3, p: 2 }}>
            <CardContent>
              <Skeleton variant="text" width="50%" height={32} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="70%" height={20} sx={{ mb: 2 }} />
              <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 2 }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* History Table Skeleton */}
      <Card sx={{ borderRadius: 3, p: 2 }}>
        <CardContent>
          <Skeleton variant="text" width="30%" height={32} sx={{ mb: 2 }} />
          <Stack spacing={1.5}>
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} variant="rounded" height={40} />
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}
